module.exports = __webpack_public_path__ + "static/img/cherry_th.9cd616e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/cherry_th.png
// module id = /WJl
// module chunks = 0